var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team-table-box"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"name","label":"姓名"}}),_c('el-table-column',{attrs:{"prop":"name","label":"职位"}}),_c('el-table-column',{attrs:{"prop":"address","label":"个人简介"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }